
import { mapState, mapMutations } from "vuex";
import { Trucks } from "@/graphql/trucks";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/heavy-vehicles",
      "fr-ca": "/vehicules-lourds",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const heavyVehiclesResponse = await client.query({
      query: Trucks,
      variables: { locale: locale },
    });
    const vehiculesLourd =
      heavyVehiclesResponse.data.vehiculeLourd.data.attributes;
    return { vehiculesLourd };
  },
  data() {
    return {
      vehiculesLourd: {},
      show: false,
      anchorSelected: "",
    };
  },
  head() {
    return {
      title: this.vehiculesLourd.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.vehiculesLourd.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.vehiculesLourd.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          90 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
